import * as svg from "../../../assets/message-solid-icon.svg";

import {iconBuilder} from "./iconBuilder";

const MessagingSolidIcon = iconBuilder(svg, "MessagingSolidIcon", "0 0 21 20");

export default MessagingSolidIcon;
